module.exports = __webpack_public_path__ + "img/arr066.039ee67a.svg";